<template>
  <el-table v-loading="loading" :data="list" height="100%" :row-class-name="tableRowClassName" size="mini">
    <el-table-column label="月份">
      <template v-slot="{row:{month,type}}">
        <span v-if="type==='sum'">{{ month|parseTime('{m}') }}月合计</span>
        <span v-else>{{ month|parseTime('{y}年{m}月') }}</span>
      </template>
    </el-table-column>
    <el-table-column label="流量来源" prop="flow_source" />
    <el-table-column label="退货前GMV" align="right">
      <template v-slot="{row:{gmv_return_bef:money}}">
        {{ money|numberFormat(2) }}
      </template>
    </el-table-column>
    <el-table-column label="退货前总佣金" align="right">
      <template v-slot="{row:{ci_return_bef:money}}">
        {{ money|numberFormat(2) }}
      </template>
    </el-table-column>
    <el-table-column label="退货后GMV" align="right">
      <template v-slot="{row:{gmv_return_aft:money}}">
        {{ money|numberFormat(2) }}
      </template>
    </el-table-column>
    <el-table-column label="退货后总佣金" align="right">
      <template v-slot="{row:{ci_return_aft:money}}">
        {{ money|numberFormat(2) }}
      </template>
    </el-table-column>
    <el-table-column label="退货率" align="right">
      <template v-slot="{row:{rate_return:rate}}">
        {{ rate|numberFormat(2) }}%
      </template>
    </el-table-column>
    <el-table-column label="退货前佣金率" align="right">
      <template v-slot="{row:{rate_return_bef:rate}}">
        {{ rate|numberFormat(2) }}%
      </template>
    </el-table-column>
    <el-table-column label="退货后佣金率" align="right">
      <template v-slot="{row:{rate_return_aft:rate}}">
        {{ rate|numberFormat(2) }}%
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { tradeStatsCommissionList } from '@/api/trade_stat_commission'

export default {
  name: 'TSCTable',
  props: {
    search: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      list: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init: async function() {
      this.loading = true
      const { stat, data } = await tradeStatsCommissionList(this.search)
      this.loading = false
      this.list = data
      this.$emit('update:stat', stat || {})
    },
    tableRowClassName({ row }) {
      if (row.type === 'sum') {
        return 'sum-row'
      } else {
        return ''
      }
    }
  }
}
</script>
<style>

</style>
